import React, { useMemo, useContext, useState, useEffect } from 'react';
import { pageSettings, storeFormDataDelivery } from '../../../initData';
import GroupFormComponent from '../../../../../../../../../widgets/form/GroupFormComponent/GroupFormComponent';
import T, { t } from '../../../../../../../../../common/components/T';
import { LangContext } from '../../../../../../../../../common/decorators/Language';
import { API_SERVER_URL, getDaysLabel } from '../../../../../../../../../common/utils/utils';
import css from './Delivery.module.scss';
import classnames from 'classnames';
import UserContext, { StoreContext } from '../../../../../../../../../common/utils/getContext';
import { getData } from '../../../../../../../../../common/utils/router';

const CartDelivery = ({
    setFormDataMain,
    formStyles,
    formDataError,
    storeData,
    setDelivery,
    delivery,
    setFormDataError,
    initValue
}) => {
    const { userToken, lang } = useContext(UserContext);
    const { cartData } = useContext(StoreContext);

    const [currierMethodsUrl, setCurrierMethodsUrl] = useState('');

    useEffect(() => {
        setCurrierMethodsUrl(
            `${API_SERVER_URL}/api/v1/shop/delivery-methods/${cartData?.id}?filter[city]=${storeData['delivery_city_id']?.['geoname_id']}`
        );
    }, [storeData, cartData]);

    // чи пусті кур'єрські методи (чи є хоч 1 для країни профілю юзера)
    const [isCurrierMethodsEmpty, setIsCurrierMethodsEmpty] = useState(false);

    useEffect(() => {
        if (userToken && cartData?.id) {
            getData(
                `/api/v1/shop/delivery-methods/${cartData?.id}?filter[country]=${initValue?.country_id?.geoname_id}`,
                userToken,
                lang
            ).then((res) => {
                if (!res?.data?.length) setIsCurrierMethodsEmpty(true);
            });
        }
    }, [userToken, lang, initValue, cartData?.id]);

    const compStyles = useMemo(() => {
        const accum = {};
        Object.keys(formStyles)?.forEach((attribute) => {
            accum[attribute] = {
                ...formStyles[attribute],
                wrapper: {
                    className: classnames(css.formControlWrap, formStyles[attribute]?.wrapper)
                }
            };
        });
        return accum;
    }, [formStyles]);
    const { translation } = useContext(LangContext);
    const fields = useMemo(
        () => storeFormDataDelivery(storeData, translation, currierMethodsUrl, initValue, isCurrierMethodsEmpty),
        [storeData, translation, currierMethodsUrl, initValue?.country_id?.currency, isCurrierMethodsEmpty]
    );

    // const getFormData = useMemo(
    //     () =>
    //         fields?.infoDelivery?.fields
    //             ? fields?.infoDelivery?.fields.reduce((accum, item) => {
    //                 if (item.type === 'location_widget') {
    //                     if (item.value || item.value === null) accum[item.attribute] = item.value;
    //                     else accum[item.attribute] = null;
    //                 }
    //                 return accum;
    //             }, {})
    //             : {},
    //     [fields]
    // );

    // хук для того, щоб при зміні корзини очищати кур'єрську службу доставки
    useEffect(() => {
        let previousUrl = '';
        setCurrierMethodsUrl((s) => {
            previousUrl = s;
            return '';
        });
        setCurrierMethodsUrl(previousUrl);
        setFormDataMain('delivery_method_price_id', null);
        setDelivery((s) => {
            if (!!s) {
                setFormDataError((s) => ({
                    ...s,
                    delivery_method_price_id: [
                        <T
                            key={Math.random()}
                            textName='change_products_currier_alert'
                            defaultStr='Товары были изменены, выберите курьерскую службу'
                        />
                    ]
                }));
            }
            return null;
        });
    }, [cartData, setFormDataMain, setDelivery, setFormDataError]);

    useEffect(() => {
        setFormDataMain('delivery_method_price_id', null);
        setDelivery(null);
    }, [storeData?.delivery_type]);

    return (
        <div className={css.CartDelivery}>
            <GroupFormComponent
                context={false}
                data={fields}
                formStyles={compStyles}
                setFormDataMain={setFormDataMain}
                formDataMain={storeData}
                sendData={{
                    url: `${API_SERVER_URL}/api/v1/admin/shop/product-categories`
                }}
                message={{
                    success: t('storeOrderSuccessful', 'Заказ успешно сохранен', '/store', translation),
                    error: false
                }}
                customStyles={css}
                customData={{ fieldsWrapper: css.storeformGlobWrap }}
                pageSettings={pageSettings}
                formDataError={formDataError}
                buttonNotShow
                funcs={{
                    ['delivery_method_price_id']: {
                        onChange: (v) => {
                            setDelivery(v);
                            setFormDataError((s) => {
                                delete s['delivery_method_price_id'];
                                return s;
                            });
                            return v;
                        }
                    },
                    ['delivery_type']: {
                        onChange: (k, value) => {
                            if (value === 'DHL') {
                                setDelivery(false);
                            }
                        }
                    }
                }}
            />
            {delivery ? (
                <div className={css.deliveryInfo}>
                    <div className={css.deliveryInfoItem}>
                        <p className={css.deliveryInfoItemLabel}>
                            <T textName='cost_of_delivery' defaultStr='Стоимость доставки' page='/store' />
                        </p>
                        <p className={css.deliveryInfoItemValue}>{delivery?.user_price?.main_price_for_currency_formatted}</p>
                    </div>
                    <div className={css.deliveryInfoItem}>
                        <p className={css.deliveryInfoItemLabel}>
                            <T textName='time_of_delivery' defaultStr='Время доставки' page='/store' />
                        </p>
                        <p className={css.deliveryInfoItemValue}>
                            <span>{`${delivery?.user_price?.delivery_days}`}</span>{' '}
                            <span>{getDaysLabel(delivery?.user_price?.delivery_days)}</span>
                        </p>
                    </div>
                </div>
            ) : null}

            {/* <div className={css.contacts}>
                {contactInfo.map((contact) => (
                    <div key={contact.id} className={css.contact}>
                        <p className={css.contactTitle}>{contact.title}</p>
                        <p className={css.contactValue}>{contact.value}</p>
                    </div>
                ))}
            </div> */}
        </div>
    );
};
export default CartDelivery;
